import { ReadonlyURLSearchParams } from "next/navigation";

export interface FilterParams {
  page?: number;
  limit?: number;
  token?: string;
  minAmount?: string;
  minPrice?: string;
  minQuantity?: string;
  tokenSymbol?: string;
  currency?: string;
  paymentMethod?: string;
  network?: string;
  timeLimit?: string;
  orderBy?: string;
  orderDirection?: "asc" | "desc";
  type?: "buy" | "sell";
  active?: boolean;
}

export const urlStateHelper = {
  pushToUrl: (params: FilterParams) => {
    if (typeof window === "undefined") return;

    const searchParams = new URLSearchParams(window.location.search);

    // Update or remove params, excluding 'all' values and empty arrays
    Object.entries(params).forEach(([key, value]) => {
      if (typeof value === "boolean" || (value && value !== "all" && value !== "")) {
        searchParams.set(key, String(value));
      } else {
        searchParams.delete(key);
      }
    });

    console.log(searchParams.toString(), "searchParams");

    // Update URL without reload and without adding to history
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState({}, "", newUrl);
  },

  // If you need to actually create a new history entry (for actual navigation)
  pushNewToUrl: (params: FilterParams) => {
    if (typeof window === "undefined") return;

    const searchParams = new URLSearchParams(window.location.search);

    Object.entries(params).forEach(([key, value]) => {
      if (typeof value === "boolean" || (value && value !== "all" && value !== "")) {
        searchParams.set(key, String(value));
      } else {
        searchParams.delete(key);
      }
    });

    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.pushState({}, "", newUrl);
  },

  parseFromUrl: (searchParams: ReadonlyURLSearchParams): FilterParams => {
    const params: FilterParams = {
      page: searchParams.get("page") ? parseInt(searchParams.get("page")!) : undefined,
      limit: searchParams.get("limit") ? parseInt(searchParams.get("limit")!) : undefined,
      token: searchParams.get("token") || undefined,
      minAmount: searchParams.get("minAmount") || undefined,
      minPrice: searchParams.get("minPrice") || undefined,
      minQuantity: searchParams.get("minQuantity") || undefined,
      tokenSymbol: searchParams.get("tokenSymbol") || undefined,
      currency: searchParams.get("currency") || undefined,
      paymentMethod: searchParams.get("paymentMethod") || undefined,
      network: searchParams.get("network") || undefined,
      timeLimit: searchParams.get("timeLimit") || undefined,
      orderBy: searchParams.get("orderBy") || undefined,
      orderDirection: (searchParams.get("orderDirection") as "" | "asc" | "desc") || undefined,
      type: (searchParams.get("type") as "buy" | "sell") || undefined,
      active: searchParams.get("active") === "true" || undefined,
    };

    // Convert undefined values to "all" for select inputs
    return params;
  },
};
